import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface PartnerStory {
  name: string;
  title: string;
  company: string;
  image: string;
  alt: string;
  quote: string;
  metrics: {
    label: string;
    value: string;
  }[];
}

const PartnerSuccessSection = () => {
  const stories: PartnerStory[] = [
  {
    name: 'Sarah Mitchell',
    title: 'Principal Consultant',
    company: 'Transform Consulting Ltd',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_18d07eb19-1763299289544.png",
    alt: 'Professional woman with short brown hair in navy blazer smiling confidently in modern office',
    quote: 'Joining AI Change Leaders transformed my practice. The methodology framework and enterprise client access allowed me to scale from solo consultant to leading a team of five specialists. The collaborative network is invaluable.',
    metrics: [
    { label: 'Revenue Growth', value: '340%' },
    { label: 'Client Projects', value: '12' },
    { label: 'Team Size', value: '5' }]

  },
  {
    name: 'James Chen',
    title: 'Managing Director',
    company: 'Digital Evolution Partners',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f5717f50-1763295673826.png",
    alt: 'Asian man in charcoal suit with glasses smiling in corporate boardroom setting',
    quote: 'The AI Change Leaders certification gave us immediate credibility with Fortune 500 clients. We\'ve delivered eight successful transformations in 18 months, with methodology support that reduced our delivery risk significantly.',
    metrics: [
    { label: 'Client Retention', value: '100%' },
    { label: 'Avg Project Value', value: '£180K' },
    { label: 'Referral Rate', value: '75%' }]

  },
  {
    name: 'Emma Thompson',
    title: 'Founder & Lead Consultant',
    company: 'Change Catalyst Group',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16af8211f-1763300159297.png",
    alt: 'Professional woman with blonde hair in teal blouse smiling warmly in bright office space',
    quote: 'The partner network opened doors I couldn\'t access independently. Collaborating with other specialists on complex engagements has elevated my expertise and allowed me to tackle enterprise-scale transformations with confidence.',
    metrics: [
    { label: 'Network Collaborations', value: '6' },
    { label: 'Enterprise Clients', value: '4' },
    { label: 'Methodology Adoption', value: '100%' }]

  }];


  return (
    <section className="py-20 lg:py-32 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-bold font-headline text-primary mb-6">
            Partner Success Stories
          </h2>
          <p className="text-lg text-muted-foreground font-body">
            Real results from consultants and firms who joined our network and transformed their practices.
          </p>
        </div>
        
        <div className="space-y-12 max-w-6xl mx-auto">
          {stories.map((story, index) =>
          <div
            key={index}
            className="bg-card rounded-xl shadow-card hover:shadow-modal transition-all duration-300 overflow-hidden border border-border">

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 p-8">
                <div className="lg:col-span-1">
                  <div className="relative w-full aspect-square rounded-lg overflow-hidden mb-4">
                    <AppImage
                    src={story.image}
                    alt={story.alt}
                    className="w-full h-full object-cover" />

                  </div>
                  <h3 className="text-xl font-bold font-headline text-primary mb-1">
                    {story.name}
                  </h3>
                  <p className="text-sm text-muted-foreground font-body mb-1">
                    {story.title}
                  </p>
                  <p className="text-sm text-secondary font-semibold font-body">
                    {story.company}
                  </p>
                </div>
                
                <div className="lg:col-span-2">
                  <div className="mb-6">
                    <Icon name="ChatBubbleLeftIcon" size={32} variant="solid" className="text-secondary/20 mb-4" />
                    <p className="text-lg text-foreground font-body leading-relaxed italic">
                      "{story.quote}"
                    </p>
                  </div>
                  
                  <div className="grid grid-cols-3 gap-4">
                    {story.metrics.map((metric, idx) =>
                  <div key={idx} className="bg-primary/5 rounded-lg p-4 text-center">
                        <div className="text-2xl font-bold font-headline text-primary mb-1">
                          {metric.value}
                        </div>
                        <div className="text-xs text-muted-foreground font-body">
                          {metric.label}
                        </div>
                      </div>
                  )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default PartnerSuccessSection;